<template>
    <b-container class="my-3">
        <page-show :alias="'forget'"></page-show>   
    </b-container>
</template>

<script>
import PageShow from "@/components/components/PageShow";
export default {
    components:{
        'page-show':PageShow
    }
}
</script>

<style lang="scss">

</style>